import Icons from "../../assets/icons/index.js";
import authFunction from "./index.function";
import { fontSizes } from "../../constants/constants.js";
import {
  Btn,
  InputField,
  FormHeading,
  AuthLayout,
  Text,
} from "../../components/index";
export default function LoginScreen() {
  const {
    navigate,
    loadingToapi,
    register,
    handleSubmit,
    setValue,
    errors,
    onSubmit,
    TextWeight,
  } = authFunction();
  return (
    <AuthLayout>
      <FormHeading
        title="Sign"
        highlightText={"In"}
        description={
          "Welcome back! Please enter your login details below to access your account."
        }
      />
      <form
        className="px-2 overflow-y-scroll hide-scrollbar"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="relative mt-2.5 2xl:mt-5">
          <InputField
            type="text"
            name="email"
            placeholder="Email Address"
            {...register("email", {
              required: "Email is required",
              // pattern: {
              //     value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
              //     message:
              //         'Please enter a valid email address',
              // },
            })}
            onChange={(value) => setValue("email", value)}
            icon={Icons.EmailIcons}
            errors={errors}
            iconStyle={"w-5 h-5 lg:h-5 lg:w-6 2xl:w-7 2xl:h-6"}
          />
        </div>
        <div className="relative mt-2.5 2xl:mt-5">
          <InputField
            type="password"
            name="password"
            placeholder="Password"
            {...register("password", { required: "Password is required" })}
            // {...register("password", {
            // required: 'Password is required',
            //     pattern: {
            //         value: /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,16}$/,
            //         message:
            //             "Password must be at least 8 characters long, include an uppercase letter, a number, and a special character.",
            //     },
            // })}
            onChange={(value) => setValue("password", value)}
            isPassword={true}
            icon={Icons.lockIcons}
            iconPasswordVisible={Icons.showPasswordIcon}
            iconPasswordHidden={Icons.hidePasswordIcon}
            is_ForgotPassword={true}
            errors={errors}
            iconStyle={"w-5 h-5 lg:h-6 lg:w-7 2xl:w-8 2xl:h-7"}
          />
        </div>
        <Btn
          type={"submit"}
          isDisabled={loadingToapi}
          loading={loadingToapi}
          isprimary={false}
          weight={TextWeight.Raleway_SemiBold}
          textSize={fontSizes.h18}
          text={"Log In"}
          color="text-white"
          hover={"hover:text-primary hover:bg-white hover:border-primary"}
          bgColor={"bg-primary border-transparent"}
          className={"mt-4 mx-auto"}
        />
      </form>
      <div className="flex justify-center items-center">
        <Text
          text={
            <>
              Don't have an account?{" "}
              <Text
                text={"Sign Up"}
                color="hover:text-primary"
                onClick={() => navigate("/selectUserType")}
                className={
                  "underline cursor-pointer transition duration-300 ease-in-out inline"
                }
              />
            </>
          }
          size={fontSizes.h18}
          weight={TextWeight.Raleway_SemiBold}
          color="text-black"
          isCenter={true}
          isTruncate={false}
          className={"inline mt-2 sm:mt-3"}
        />
      </div>
    </AuthLayout>
  );
}
